<template>
  <div class="pricing__plans">
    <PagesPricingPlanCard
        :info="PLANS[UserPlan.Standard]"
        :period="period"
        :plan="UserPlan.Standard"
        @choosePlan="emit('choosePlan', $event)"
    />
    <PagesPricingPlanCard
        :info="PLANS[UserPlan.Pro]"
        :period="period"
        :plan="UserPlan.Pro"
        is-popular
        @choosePlan="emit('choosePlan', $event)"
    />
    <PagesPricingPlanCard
        :period="period"
        :plan="UserPlan.Business"
        @choosePlan="emit('choosePlan', $event)"
    />
  </div>

  <div class="carousel-wrapper">
    <div class="carousel">
      <Swiper
          :breakpoints="{
          '200': {
            slidesPerView: 1.2,
            spaceBetween: 16,
          },
          '600': {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          '980': {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        }"
          :centered-slides="true"
          :grabCursor="true"
          :initial-slide="1"
          :loop="false"
          :modules="[Pagination]"
          :pagination="true"
          @init="onSwiperInit"
      >
        <SwiperSlide>
          <PagesPricingPlanCard
              :info="PLANS[UserPlan.Standard]"
              :period="period"
              :plan="UserPlan.Standard"
              @choosePlan="emit('choosePlan', $event)"
          />
        </SwiperSlide>
        <SwiperSlide>
          <PagesPricingPlanCard
              :info="PLANS[UserPlan.Pro]"
              :period="period"
              :plan="UserPlan.Pro"
              is-popular
              @choosePlan="emit('choosePlan', $event)"
          />
        </SwiperSlide>
        <SwiperSlide>
          <PagesPricingPlanCard
              :period="period"
              :plan="UserPlan.Business"
              @choosePlan="emit('choosePlan', $event)"
          />
        </SwiperSlide>
      </Swiper>
    </div>
  </div>

</template>

<script lang="ts" setup>
import {PLANS} from "~/data/plans";
import {PlanDurationType, UserPlan} from "~/graphql/generated/schema-types";
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Swiper as SwiperClass} from "swiper";
import {Pagination} from 'swiper/modules';
import 'swiper/swiper-bundle.css';

const emit = defineEmits<{
  (e: 'choosePlan', plan: UserPlan): void
}>()
const props = defineProps<{
  period: PlanDurationType
}>()


const carousel = ref<SwiperClass | null>(null);
const onSwiperInit = (e: any) => {
  if (!carousel.value) {
    carousel.value = e
  }
}
</script>

<style lang="scss" scoped>
@use "/assets/scss/components/carousel";

.carousel {
  display: none;
  margin: 0 -16px;
  @media screen and (max-width: 979px) {
    display: flex;
  }

  .swiper {
    padding-bottom: 50px;

    &:deep(.swiper-pagination-bullet) {
      background-color: var(--surfaces-highest-container);
      opacity: 1;
      transition: all 0.3s;
    }

    &:deep(.swiper-pagination-bullet-active) {
      background-color: var(--accent-on-surface);
      width: 20px;
      border-radius: 4px;
    }
  }

  .swiper-wrapper {
    padding: 16px;
    align-items: stretch;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: stretch;
    align-self: stretch;
    height: unset;
  }
}

.pricing__plans {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  align-items: flex-end;
  justify-content: center;
  margin: 0 auto;
  max-width: 1024px;
  @media screen and (max-width: 979px) {
    display: none;
  }
}
</style>
